import { ChevronRightIcon } from "lucide-react-native";

import { VnBox } from "@/components/VnBox";
import { VnCard } from "@/components/VnCard";
import { VnIcon } from "@/components/VnIcon";
import { VnLink } from "@/components/VnLink";
import { VnText } from "@/components/VnText/VnText";
import { getApplicationTypeColor } from "@/utils/applications";
import { cn } from "@/utils/tailwind";

/**
 * Persistent "Work requirements" section. Shows a single link into the Medicaid
 * work requirements list. Visibility is gated by the caller (only once the
 * household has been screened).
 */
const WorkRequirementsSection = () => (
  <VnBox className="gap-6">
    <VnText
      variant="headerTwo"
      i18nKey="native:workRequirements.sectionTitle"
    />

    <VnLink href={{ pathname: "/(authed)/work-requirements" }} asChild>
      <VnCard className="relative flex flex-row items-center justify-between overflow-hidden">
        <VnBox
          className={cn(
            "absolute left-0 size-3 h-full",
            getApplicationTypeColor("MEDICAID"),
          )}
        />
        <VnText
          variant="lgMedium"
          className="ml-2"
          i18nKey="native:workRequirements.medicaidWorkRequirements"
        />
        <VnIcon as={ChevronRightIcon} />
      </VnCard>
    </VnLink>
  </VnBox>
);

export { WorkRequirementsSection };
